import { CheckCircle2 } from "lucide-react";

const POINTS = [
  "Complete Renovation",
  "Clear Quotations",
  "Professional Workmanship",
  "One Team From Start to Finish",
];

export default function TrustBar() {
  return (
    <section data-testid="trust-bar" className="bg-white border-b border-neutral-200 py-5 lg:py-6">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 lg:gap-8">
          {POINTS.map((p) => (
            <div key={p} className="flex items-center gap-2.5">
              <CheckCircle2 className="w-5 h-5 text-[#C5A059] flex-shrink-0" />
              <span className="text-sm lg:text-[15px] font-medium text-neutral-800 leading-tight">{p}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
